module.exports = __webpack_public_path__ + "media/images/icons/dropdown_gray-5816cdfbcf8f290d19c4f246335988a1.svg";